import { ScreenConfig } from "../types";

/**
 * Fetches author-defined height (px) for a given localRef
 * 
 */
export function getElementHeightByLocalRef(
    screenConfig: ScreenConfig | undefined,
    localRef: string | undefined
): number | undefined {
    if (!screenConfig || !localRef) return undefined;

    const sections = screenConfig.stage?.sections;
    if (!sections) return undefined;

    for (const section of sections) {
        const rows = section.rows;
        if (!rows) continue;

        for (const row of rows) {
            const columns = row.columns;
            if (!columns) continue;

            for (const column of columns) {
                const stageElements = column.stageElements;
                if (!stageElements) continue;

                const element = stageElements.find(
                    (el) => el.localRef === localRef
                );

                if (!element) continue;

                if (typeof element.height === "number") {
                    return element.height;
                }

                const styleHeight = element.style?.height;
                if (typeof styleHeight === "number") {
                    return styleHeight;
                }
                if (typeof styleHeight === "string") {
                    const parsed = parseInt(styleHeight, 10);
                    if (!Number.isNaN(parsed)) {
                        return parsed;
                    }
                }

                if (typeof element.layout?.height === "number") {
                    return element.layout.height;
                }

                // Found element but no usable height
                return undefined;
            }
        }
    }

    return undefined;
}
